<template>
  <div class="container" style="heigth: 100%; overflow: auto">
    <!--订单详情页--->
    <div style="text-align: left">
      <span class="table_header">
        <strong>支付明细</strong>
      </span>
      <el-table
        :data="tableData.orderPriceData"
        border
        class="table"
        style="width: 75.9%"
      >
        <el-table-column
          align="center"
          label="订单原价"
          prop="totalMoney"
          width="100"
        >
          <template slot-scope="scope">
            <span>{{ scope.row.totalMoney | formatMoney }}</span>
          </template>
        </el-table-column>
        <el-table-column
          align="center"
          label="优惠金额"
          prop="benfitPrice"
          width="100"
        >
          <template slot-scope="scope">
            <span>{{ scope.row.benfitPrice | formatMoney }}</span>
          </template>
        </el-table-column>
        <el-table-column
          align="center"
          label="应收金额"
          prop="orderMoney"
          width="100"
        >
          <template slot-scope="scope">
            <span>{{ scope.row.orderMoney | formatMoney }}</span>
          </template>
        </el-table-column>
        <el-table-column
          align="center"
          label="实收金额"
          prop="realReceiptMoney"
          width="100"
        >
          <template slot-scope="scope">
            <span>{{ scope.row.realReceiptMoney | formatMoney }}</span>
          </template>
        </el-table-column>
        <el-table-column
          align="center"
          label="里程费"
          prop="milesPrice"
          width="120"
        >
          <template slot-scope="scope">
            <span>{{ scope.row.milesPrice | formatMoney }}</span>
          </template>
        </el-table-column>
        <el-table-column
          align="center"
          label="时长费"
          prop="durationPrice"
          width="120"
        >
          <template slot-scope="scope">
            <span>{{ scope.row.durationPrice | formatMoney }}</span>
          </template>
        </el-table-column>
        <el-table-column
          align="center"
          label="附加费"
          prop="additionFee"
          width="140"
        >
          <template slot-scope="scope">
            <span>{{ scope.row.additionFee | formatMoney }}</span>
          </template>
        </el-table-column>
         <el-table-column
          align="center"
          label="服务费"
          prop="serviceFee"
          width="140"
        >
          <template slot-scope="scope">
            <span>{{ scope.row.serviceFee | formatMoney }}</span>
          </template>
        </el-table-column>
        <el-table-column
          align="center"
          label="低速加收费用"
          prop="lowSpeedPrice"
          width="120"
        >
          <template slot-scope="scope">
            <span>{{ scope.row.lowSpeedPrice | formatMoney }}</span>
          </template>
        </el-table-column>
       <el-table-column
          align="center"
          label="预约服务费"
          prop="bookTip"
          width="100"
        >
          <template slot-scope="scope">
            <span>{{ scope.row.bookTip | formatMoney }}</span>
          </template>
        </el-table-column>
        <el-table-column
          align="center"
          label="远途加价"
          prop="farUpPrice"
          width="100"
        >
          <template slot-scope="scope">
            <span>{{ scope.row.farUpPrice | formatMoney }}</span>
          </template>
        </el-table-column>
        <el-table-column
          align="center"
          label="其他加价"
          prop="otherUpPrice"
          width="100"
        >
          <template slot-scope="scope">
            <span>{{ scope.row.otherUpPrice | formatMoney }}</span>
          </template>
        </el-table-column>
        <el-table-column
          align="center"
          label="出城费"
          prop="outChargePrice"
          width="100"
        >
          <template slot-scope="scope">
            <span>{{ scope.row.outChargePrice | formatMoney }}</span>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <br />

    <!--订单基本信息-->
    <div style="text-align: left">
      <span class="table_header">订单基本信息</span>
      <span>
        <el-button type="text" size="mini" @click="openOrderStatusLog">
          &nbsp;&nbsp;&nbsp;&nbsp;订单状态流转</el-button
        >
      </span>
      <table class="baseInfo">
        <tr>
          <td>订单号</td>
          <td>
            {{ tableData.orderBaseInfo.orderNo }} &nbsp;&nbsp;
            <el-link
              type="primary"
              v-if="
                tableData.orderBaseInfo.partnerOrderId != null &&
                tableData.orderBaseInfo.partnerOrderId != ''
              "
              style="font-size: 10px"
              @click="showTripartiteNo"
              >显示三方订单号</el-link
            >
            {{ tripartiteNo }}
          </td>

          <td>订单机构</td>
          <td>{{ tableData.orderBaseInfo.organizationStr }}</td>
          <td>订单类型</td>
          <td>{{ tableData.orderBaseInfo.typeStr }}</td>
          <td>订单来源</td>
          <td>{{ tableData.orderBaseInfo.orderSourceStr }}</td>
          <td>订单状态</td>
          <td>
            <el-tag type="danger" effect="dark"
              >{{ tableData.orderBaseInfo.orderStatusStr
              }}<san v-if="alreadyRefund == true"
                >【{{ refuldResult }}】</san
              ></el-tag
            >&nbsp;&nbsp;
            <el-tag
              @click="canncelOrder"
              type="success"
              effect="dark"
              v-if="
                tableData.orderBaseInfo.orderStatus === 1 ||
                tableData.orderBaseInfo.orderStatus === 2 ||
                tableData.orderBaseInfo.orderStatus === 3 ||
                tableData.orderBaseInfo.orderStatus === 4 ||
                tableData.orderBaseInfo.orderStatus === 5
              "
              >取消订单</el-tag
            >
            <span
              v-if="
                tableData.orderBaseInfo.orderStatus === 7 ||
                tableData.orderBaseInfo.orderStatus === 8 ||
                tableData.orderBaseInfo.orderStatus === 9
              "
            >
              <el-tag
                type="warning"
                effect="dark"
                v-if="
                  tableData.orderBaseInfo.driverName == null ||
                  tableData.orderBaseInfo.driverName === ''
                "
                >无应答取消</el-tag
              >
              <el-tag
                type="warning"
                effect="dark"
                v-if="
                  tableData.orderBaseInfo.driverName != null &&
                  tableData.orderBaseInfo.driverName != ''
                "
                >接单后取消</el-tag
              >
              {{ tableData.orderBaseInfo.cancelTime }}
            </span>
          </td>
        </tr>
        <tr>
          <td>下单时间</td>
          <td>{{ tableData.orderBaseInfo.orderTime }}</td>
          <td>派单时间</td>
          <td>{{ tableData.orderBaseInfo.orderSendTime }}</td>
          <td>完成时间</td>
          <td>{{ tableData.orderBaseInfo.orderCompleteTime }}</td>
          <td>支付方式</td>
          <td>
            <span v-if="tableData.orderBaseInfo.payWay === 1">钱包支付</span>
            <span v-if="tableData.orderBaseInfo.payWay === 2">微信支付分</span>
            <span v-if="tableData.orderBaseInfo.payWay === 3">扫码支付</span>
          </td>
          <td>发票状态</td>
          <td>
            {{ tableData.orderBaseInfo.invoiceStatus | formatInvoiceStatus }}
            <el-tag
              type="warning"
              effect="dark"
              v-if="
                tableData.orderBaseInfo.orderStatus === 6 &&
                tableData.orderBaseInfo.invoiceStatus === 0
              "
              @click="applyInvoice"
              >申请开票</el-tag
            >
          </td>
        </tr>
        <tr>
          <td>预计出发地</td>
          <td>{{ tableData.orderBaseInfo.planDeparture }}</td>
          <td>预计上车时间</td>
          <td>{{ tableData.orderBaseInfo.planDepartTime }}</td>
          <td>预计目的地</td>
          <td>{{ tableData.orderBaseInfo.planDestination }}</td>
          <td>预计价格</td>
          <td>{{ tableData.orderBaseInfo.price | formatMoney }}</td>
          <td>预计行驶里程</td>
          <td>{{ tableData.orderBaseInfo.planMile }}(公里)</td>
        </tr>
        <tr>
          <td>实际出发地</td>
          <td>{{ tableData.orderBaseInfo.realDeparture }}</td>
          <td>实际上车时间</td>
          <td>{{ tableData.orderBaseInfo.realDepTime }}</td>
          <td>实际目的地</td>
          <td>{{ tableData.orderBaseInfo.realDestination }}</td>
          <td>实际下车时间</td>
          <td>{{ tableData.orderBaseInfo.realDestTime }}</td>
          <td>实际行驶里程</td>
          <td>{{ tableData.orderBaseInfo.driveMile }}(公里)</td>
        </tr>
        <tr>
          <td>下单人姓名</td>
          <td>{{ tableData.orderBaseInfo.passengerName }}</td>
          <td>下单人电话</td>
          <td>{{ tableData.orderBaseInfo.passengerPhone }}</td>
          <td>乘车人姓名:</td>
          <td>{{ tableData.orderBaseInfo.contactName }}</td>
          <td>乘车人电话</td>
          <td>{{ tableData.orderBaseInfo.contactPhone }}</td>
          <td>乘车人数</td>
          <td>{{ tableData.orderBaseInfo.passengerNum }}</td>
        </tr>
        <tr>
          <td>司机姓名</td>
          <td>{{ tableData.orderBaseInfo.driverName }}</td>
          <td>司机电话</td>
          <td>{{ tableData.orderBaseInfo.driverPhone }}</td>
          <td>车牌号</td>
          <td>{{ tableData.orderBaseInfo.vehicleNo }}</td>
          <td>车辆型号</td>
          <td>{{ tableData.orderBaseInfo.brand }}</td>
          <td>车辆颜色</td>
          <td>{{ tableData.orderBaseInfo.plateColor }}</td>
        </tr>
        <tr>
          <td>下单地区</td>
          <td>{{ tableData.orderBaseInfo.addressStr }}</td>
          <td>下单端口</td>
          <td>{{ tableData.orderBaseInfo.clientTypeStr }}</td>
          <td>优惠券</td>
          <td>{{ tableData.orderBaseInfo.couponId }}</td>
          <td>隐私号</td>
          <td>
            {{ tableData.orderBaseInfo.secretPhone }}
            <!-- <span v-if="tableData.orderBaseInfo.secretPhone!=null" ><a href="javascript:void(0)" @click="queryRecording">(录音查询)</a></span> -->
          </td>
          <td>订单时长</td>
          <td>{{ tableData.orderBaseInfo.duration }}</td>
        </tr>
      </table>

      <div
        v-if="
          tableData.orderBaseInfo.orderStatus === 7 ||
          tableData.orderBaseInfo.orderStatus === 8 ||
          tableData.orderBaseInfo.orderStatus === 9
        "
      >
        <span
          >接单时司机与乘客的距离：<strong>{{
            tableData.orderBaseInfo.positionDistance
          }}</strong>
          公里</span
        >&nbsp;&nbsp;&nbsp;&nbsp;
        <span
          >司机接单到订单取消时间间隔：<strong>{{
            tableData.orderBaseInfo.cancelIntervalTime
          }}</strong>
          分钟</span
        >&nbsp;&nbsp;&nbsp;&nbsp;
        <span v-if="tableData.orderBaseInfo.orderStatus === 8"
          >司机取消时司机是否达到上车点：<strong>{{
            tableData.orderBaseInfo.driverArriveGetOnPoint
          }}</strong></span
        >
      </div>
    </div>
    <br />

    <div class="big_div">
      <!--司机端上传的订单录音-->
      <el-card
        class="box-card_left"
        :style="{ height: cardHeight.leftCard + 'px' }"
      >
        <div slot="header" class="clearfix">
          <span class="table_header">订单录音</span>
          <el-button
            style="float: right; padding: 3px 0"
            type="text"
            @click="queryOrderRecording"
            >刷新录音</el-button
          >
        </div>
        <div style="text-align: left" v-if="orderRecordingMusic.length > 0">
          <!--music：当前播放的音乐。 list：播放列表 ：showlrc：是否显示歌词-->
          <aplayer
            :music="orderRecordingMusic[0]"
            :list="orderRecordingMusic"
            :float="true"
          ></aplayer>
        </div>
        <div v-else>暂无录音</div>
      </el-card>

      <!--华为隐私号电话录音-->
      <el-card class="box-card_right_top" id="boxCardRightTop">
        <div slot="header" class="clearfix">
          <span class="table_header">隐私号录音</span>
        </div>
        <div style="text-align: left" v-if="recordingList.length > 0">
          <el-table :data="recordingList" border class="table">
            <el-table-column
              prop="callInTime,fwdAlertingTime,fwdAnswerTime,callEndTime"
              label="呼叫时间"
              width="250px"
              align="center"
            >
              <template slot-scope="scope">
                呼叫发起时间：{{ scope.row.callInTime }}
                <br />
                呼叫振铃时间：{{ scope.row.fwdAlertingTime }}
                <br />
                呼叫接通时间：{{ scope.row.fwdAnswerTime }}
                <br />
                呼叫挂断时间：{{ scope.row.callEndTime }}
              </template>
            </el-table-column>
            <el-table-column
              prop="callerNum,fwdDstNum,fwdDisplayNum"
              label="呼叫号码"
              width="250px"
              align="center"
            >
              <template slot-scope="scope">
                主叫号码：{{ scope.row.callerNum }}
                <br />
                被叫号码：{{ scope.row.fwdDstNum }}
                <br />
                主显号码：{{ scope.row.fwdDisplayNum }}
                <br />
              </template>
            </el-table-column>
            <el-table-column
              prop="recordDirection"
              label="通话类型"
              width="120px"
              align="center"
            ></el-table-column>
            <el-table-column
              prop="recordResult"
              label="通话结果"
              width="120px"
              align="center"
            ></el-table-column>
            <el-table-column
              prop="recordFlag"
              label="是否录音"
              width="120px"
              align="center"
            >
              <template slot-scope="scope">
                <span v-if="scope.row.recordFlag === 1">有录音</span>
                <span v-if="scope.row.recordFlag === 0">无录音</span>
              </template>
            </el-table-column>
            <el-table-column
              prop="duration"
              label="通话时长(分钟)"
              width="120px"
              align="center"
            >
              <template slot-scope="scope">{{ scope.row.duration }}</template>
            </el-table-column>
            <el-table-column label="播放录音" width="100px" align="center">
              <template slot-scope="scope">
                <span>
                  <a
                    href="javascript:void(0)"
                    @click="playRecording(scope.$index, scope.row)"
                    :disabled="
                      scope.row.ossUrl == null || scope.row.ossUrl === ''
                    "
                    ><i class="el-icon-headset"></i
                  ></a>
                  <!-- <a href="javascript:void(0)" @click="downloadRecording(scope.$index, scope.row)" :disabled="scope.row.ossUrl==null || scope.row.ossUrl===''"><i class="el-icon-bottom"></i></a> -->
                </span>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div v-else>暂无录音</div>
      </el-card>

      <!--司机端订单报备-->
      <el-card class="box-card_right_bottom" id="boxCardRightBottom">
        <div slot="header" class="clearfix">
          <span class="table_header">订单报备</span>
        </div>
        <div style="text-align: left" v-if="orderReportList.length > 0">
          <el-table
            :data="orderReportList"
            style="width: 92%"
            border
            class="table"
          >
            <el-table-column
              prop="driverName"
              label="报备司机"
              width="120px"
              align="center"
            ></el-table-column>
            <el-table-column
              prop="reportTime"
              label="报备时间"
              width="200px"
              align="center"
            ></el-table-column>
            <el-table-column
              prop="type"
              label="问题类别"
              width="120px"
              align="center"
            >
              <template slot-scope="scope">
                <span v-if="scope.row.type === 1">车辆问题</span>
                <span v-if="scope.row.type === 2">乘客问题</span>
                <span v-if="scope.row.type === 3">软件问题</span>
                <span v-if="scope.row.type === 4">突发事故</span>
                <span v-if="scope.row.type === 5">个人问题</span>
                <span v-if="scope.row.type === 6">其他问题</span>
              </template>
            </el-table-column>
            <el-table-column
              prop="contentText"
              label="报备文字"
              width="150px"
              align="center"
            ></el-table-column>

            <el-table-column
              prop="contentImgUrlList"
              label="报备图片"
              width="300"
              :show-overflow-tooltip="true"
              align="center"
            >
              <template slot-scope="scope">
                <!-- <img :src="item" v-for="(item,index) in scope.row.contentImgUrlList"  :key="index"  class="tabImg"/> -->

                <span
                  v-for="(item, index6) in scope.row.contentImgUrlList"
                  :key="index6"
                >
                  <el-popover placement="left" trigger="click" width="300">
                    <!--这个Img是点击预览的(放大后)-->
                    <img :src="item" class="tabImgPopup" />
                    <!--这个Img是表格中的图片-->
                    <img
                      slot="reference"
                      :src="item"
                      :alt="item"
                      class="tabImg"
                    />
                  </el-popover>
                </span>
              </template>
            </el-table-column>
            <el-table-column
              prop="contentRadioUrl"
              label="报备录音"
              width="100px"
              align="center"
            >
              <template slot-scope="scope">
                <span>
                  <a
                    href="javascript:void(0)"
                    @click="playOrderRadio(scope.$index, scope.row)"
                    :disabled="
                      scope.row.contentRadioUrl == null ||
                      scope.row.contentRadioUrl === ''
                    "
                    ><i class="el-icon-headset"></i
                  ></a>
                </span>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div v-else>暂未查询到报备信息</div>
      </el-card>
    </div>
    <br />

    <!--订单评价-->
    <el-card class="box-card_evaluate">
      <div slot="header" class="clearfix">
        <span class="table_header">订单评价</span>
      </div>
      <div v-if="tableData.orderEvaluateDetailVo != null">
        <div v-if="tableData.orderEvaluateDetailVo.servicescore != null">
          <strong>评价星级：</strong>
          {{ tableData.orderEvaluateDetailVo.servicescore }}星
        </div>
        <div v-else><strong>评价星级：</strong>未评价</div>

        <div v-if="tableData.orderEvaluateDetailVo.evaluateDetail.length > 0">
          <div
            v-for="(item, index1) in tableData.orderEvaluateDetailVo
              .evaluateDetail"
            :key="index1"
          >
            <span>
              <strong>{{ item.content }}:</strong>
            </span>
            <span v-for="(it, ix) in item.childrenContent" :key="ix"
              >{{ it }}、</span
            >
          </div>
        </div>
        <div v-else>
          <p>未填写反馈信息</p>
        </div>
      </div>
    </el-card>

    <br />
    <!--订单留言-->
    <div style="text-align: left">
      <span class="table_header">订单留言</span>
      <br />
      <el-input
        type="textarea"
        v-model="newLeaveMessage"
        placeholder="可在此处添加您的订单留言,为了方便查看,推荐给留言加上前缀【xxx留言】,如【客服留言】"
        style="width: 60%"
        :rows="4"
      ></el-input>
      <el-button
        type="success"
        size="mini"
        :disabled="newLeaveMessage === '' ? true : false"
        @click="saveMessage"
        >保存</el-button
      >
      <br />
      <br />
      <div id="leaveDiv" v-if="tableData.orderLeaveMessage.length > 0">
        <ul v-for="(item, index2) in tableData.orderLeaveMessage" :key="index2">
          <li>
            <strong>{{ item.handler }}</strong>
            {{ item.messageTime }}
          </li>
          <li>{{ item.content }}</li>
        </ul>
      </div>
    </div>
    <hr />
    <br />
    <!--订单处理start -->
    <div style="text-align: left">
      <span class="table_header">订单处理操作</span>
      <div style="margin-top: 5px">
        <el-button
          v-hasPermission="'order:orderRefund'"
          type="success"
          size="mini"
          @click="refundClick"
          :disabled="refurndForm.realReceiptMoney === 0 || alreadyRefund == true ||
            (tableData.orderBaseInfo.orderStatus != 6 && tableData.orderBaseInfo.orderStatus != 7 && tableData.orderBaseInfo.orderStatus != 8 && tableData.orderBaseInfo.orderStatus != 9)  "
          style="margin-left: 1%"
          >退款</el-button
        >

        <el-button
          v-hasPermission="'order:orderRefund'"
          type="success"
          size="mini"
          @click="changeMoneyClick"
          :disabled="tableData.orderBaseInfo.orderStatus != 5"
          style="margin-left: 1%"
          >调帐</el-button
        >
      </div>
    </div>
    <hr />
    <br />

    <!--订单处理end -->
    <!--判责信息start -->
    <div
      style="text-align: left"
      v-if="orderTicketClose == false"
      v-hasPermission="'orderJudge:saveOrderJudge'"
    >
      <span class="table_header">判责信息</span>
      <div style="margin-top: 5px">
        <el-form ref="judgeForm" :model="judgeForm" label-width="120px">
          <el-form-item label="判责工单类型：">
            <el-select v-model="judgeForm.ticketType" placeholder="请选择">
              <el-option
                v-for="item in ticketTypeOption"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="责任主体：">
            <el-select v-model="judgeForm.dutySubject" placeholder="请选择">
              <el-option
                v-for="item in dutySubjectOption"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="判责工单状态：">
            <el-select v-model="judgeForm.ticketStatus" placeholder="请选择">
              <el-option
                v-for="item in ticketStatusOption"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="处理备注：">
            <el-input v-model="judgeForm.mark" style="width: 500px"></el-input>
          </el-form-item>
          <el-button
            type="success"
            size="mini"
            style="margin-left: 6%"
            @click="commitJudge"
            >提交判责工单</el-button
          >
        </el-form>
      </div>
      <hr />
    </div>

    <!--判责信息操作end -->
    <!--日志start -->
    <div style="text-align: left">
      <!--订单处理日志-->
      <span class="table_header">订单处理日志</span>
      <div
        class="orderHandlerLog"
        v-for="(item, index3) in orderMarkList"
        :key="index3"
      >
        <span>{{ item.createTime }}</span
        ><br />
        <span
          >{{ item.operator }} &nbsp;【{{
            item.specialOperation | operationFilter
          }}】&nbsp;&nbsp;{{ item.operationContent }}&nbsp;&nbsp;{{
            item.remark
          }}</span
        >
      </div>
      <br />

      <!--判责日志-->
      <span class="table_header">判责日志</span>
      <div
        class="judgeDutyLong"
        v-for="(item, index4) in orderJudgeList"
        :key="index4"
      >
        <span>{{ item.createTime }}</span
        ><br />
        <span>{{ item.operator }} &nbsp;创建判责工单</span><br />
        <span
          >判责工单类型：&nbsp;{{ item.ticketType | ticketTypeFilter }} </span
        ><br />
        <span> 责任主体:&nbsp; {{ item.dutySubject | dutySubjectFilter }} </span
        ><br />
        <span> 处理备注: &nbsp;{{ item.mark }} </span><br />
        <span
          >判责工单状态：&nbsp;{{
            item.ticketStatus | ticketStatusFilter
          }} </span
        ><br />
      </div>
    </div>
    <!--日志end -->
    <br />
    <br />

    <el-dialog title="取消订单原因" :visible.sync="canncelVisibile" width="30%">
      <el-input
        type="textarea"
        v-model="remark"
        placeholder="取消原因"
      ></el-input>
      <div></div>
      <div slot="footer">
        <el-button @click="canncelVisibile = false">取 消</el-button>
        <el-button type="primary" @click="saveCanncel">确 定</el-button>
      </div>
    </el-dialog>

    <el-dialog title="发票申请" :visible.sync="openInvoiceVisibile" width="30%">
      <el-form :model="openInvoiceForm">
        <el-form-item label="发票抬头:" :label-width="100">
          <el-input
            v-model="openInvoiceForm.title"
            style="width: 197px"
          ></el-input>
        </el-form-item>
        <el-form-item label="发票税号:" :label-width="100">
          <el-input
            v-model="openInvoiceForm.tax"
            style="width: 197px"
          ></el-input>
        </el-form-item>
        <el-form-item label="发票邮箱:" :label-width="100">
          <el-input
            v-model="openInvoiceForm.email"
            style="width: 197px"
          ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="invoiceCommit">确 定</el-button>
      </div>
    </el-dialog>

    <el-dialog
      title="订单状态流转"
      :visible.sync="openOrderStatusVisibile"
      width="30%"
    >
      <div>
        <el-timeline>
          <el-timeline-item
            v-for="(item, index5) in orderStatusList"
            :key="index5"
            :timestamp="item.orderStatusStr"
            placement="top"
          >
            {{ item.createTime }} &nbsp;&nbsp; {{ item.operator }}
          </el-timeline-item>
        </el-timeline>
      </div>
    </el-dialog>

    <el-dialog title="申请退款" :visible.sync="openRefundVisible" width="30%">
      <p class="refundP">订单号：{{ orderNo }}</p>
      <p class="refundP">订单金额：{{ refurndForm.orderMoney }}元</p>
      <p class="refundP">已收金额：{{ refurndForm.realReceiptMoney }}元</p>
      <div>
        <el-form ref="refurndForm" :model="refurndForm" label-width="80px">
          <el-form-item label="退款金额">
            <el-input
              v-model="refurndForm.refundMoney"
              style="width: 179px"
            ></el-input>
            <el-button type="text" @click="setRefundMoney">全额</el-button>
          </el-form-item>
          <el-form-item label="退款原因">
            <el-input
              v-model="refurndForm.cause"
              style="width: 179px"
            ></el-input>
          </el-form-item>
        </el-form>
      </div>
      <div slot="footer">
        <el-button @click="openRefundVisible = false">取 消</el-button>
        <el-button type="primary" @click="saveRefund">确 定</el-button>
      </div>
    </el-dialog>

    <el-dialog
      title="修改价格"
      :visible.sync="openChangeMoneyVisible"
      width="30%"
    >
      <div>
        <p class="refundP">订单号：{{ changeMoney.orderNo }}</p>
        <p class="refundP">应收金额：{{ changeMoney.originOrderMoney }}元</p>
        <p class="refundP">
          里程费：{{
            changeMoney.originMilesPrice
          }}元&nbsp;&nbsp;&nbsp;&nbsp;时长费：{{
            changeMoney.originDurationPrice
          }}元&nbsp;&nbsp;&nbsp;&nbsp;附加费：{{
            changeMoney.originadditionFee
          }}元
        </p>
        <el-form ref="changeMoney" :model="changeMoney" label-width="80px">
          <el-form-item label="里程费：">
            <el-input
              v-model="changeMoney.distancePrice"
              placeholder="仅支持输入大于等于0的数字"
              style="width: 179px"
            ></el-input>
          </el-form-item>
          <el-form-item label="时长费：">
            <el-input
              v-model="changeMoney.durationPrice"
              placeholder="要求同上"
              style="width: 179px"
            ></el-input>
          </el-form-item>
          <el-form-item label="附加费：">
            <el-input
              v-model="changeMoney.additionPrice"
              placeholder="要求同上"
              style="width: 179px"
            ></el-input>
          </el-form-item>
        </el-form>
      </div>
      <div slot="footer">
        <el-button @click="openChangeMoneyVisible = false">取 消</el-button>
        <el-button type="primary" @click="saveChangePrice">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import aplayer from "vue-aplayer";
//vue中监控元素大小变化element-resize-detector
import elementResizeDetectorMaker from "element-resize-detector";
export default {
  components: { aplayer },
  name: "orderDetail",
  data() {
    return {
      orderNo: "",
      newLeaveMessage: "",
      canncelVisibile: false,
      openInvoiceVisibile: false,
      openOrderStatusVisibile: false,
      openRefundVisible: false,
      openChangeMoneyVisible: false,

      remark: "",
      orderId: "",
      tableData: {
        //订单价格
        orderPriceData: [],
        //订单基本信息
        orderBaseInfo: {},
        //订单留言
        orderLeaveMessage: [],
        //订单评价
        orderEvaluateDetailVo: {
          servicescore: "",
          evaluateDetail: [],
        },
      },
      openInvoiceForm: {
        orderNo: "",
        title: "",
        tax: "",
        email: "",
      },

      /**电话录音*/
      recordingList: [],
      musicList: [],
      /**司机订单报备 */
      orderReportList: [],
      /**订单全程录音 */
      orderRecordingMusic: [],
      /**三个el-card的高度 */
      cardHeight: {
        //左边
        leftCard: "",
        //右上
        rightTopCard: "",
        //右下
        rightBottomCard: "",
      },
      //三方订单号
      tripartiteNo: "",
      /**订单状态 */
      orderStatusList: [],
      /**订单处理日志 */
      orderMarkList: [],
      /**退款 */
      refurndForm: {
        orderId: "",
        orderMoney: 0.0,
        realReceiptMoney: 0.0,
        refundMoney: 0.0,
        cause: "",
      },
      changeMoney: {
        orderId: "",
        distancePrice: "",
        durationPrice: "",
        additionPrice: "",

        orderNo: "",
        originOrderMoney: 0.0,
        originMilesPrice: 0.0,
        originDurationPrice: 0.0,
        originadditionFee: 0.0,
      },
      judgeForm: {
        orderId: "",
        ticketType: "",
        dutySubject: "",
        mark: "",
        ticketStatus: "",
      },
      /**订单判责日志 */
      orderJudgeList: [],
      //判决工单类型 1.成交率 2.行程服务 3.费用申诉
      ticketTypeOption: [
        {
          value: 1,
          label: "成交率",
        },
        {
          value: 2,
          label: "行程服务",
        },
        {
          value: 3,
          label: "费用申诉",
        },
      ],
      //责任主体 1.乘客主责 2.司机主责 3.双方无责
      dutySubjectOption: [
        {
          value: 1,
          label: "乘客主责",
        },
        {
          value: 2,
          label: "司机主责",
        },
        {
          value: 3,
          label: "双方无责",
        },
      ],
      //判责工单状态 1开启 2关闭
      ticketStatusOption: [
        {
          value: 1,
          label: "开启",
        },
        {
          value: 2,
          label: "关闭",
        },
      ],
      //当前订单已退款
      alreadyRefund: false,
      refuldResult: "",
      //最后一条判责工单状态是关闭的
      orderTicketClose: false,
    };
  },

  created() {
    let orderNo = this.$route.query.orderNo;
    if (orderNo && orderNo != "" && orderNo != null) {
      this.orderNo = orderNo;
      this.getOrderDetail();
      this.queryOrderRecording();
      this.queryOrderReport();
      this.queryRecording();
    }
  },
  mounted() {
    //左边的一个元素的高度=右边两个元素的高度+两个元素中间的间隔，动态去获取右边元素的高度
    let erd = elementResizeDetectorMaker();
    erd.listenTo(document.getElementById("boxCardRightTop"), (element) => {
      this.cardHeight.rightTopCard = element.offsetHeight;
      this.cardHeight.leftCard =
        this.cardHeight.rightTopCard + this.cardHeight.rightBottomCard + 5;
    });
    erd.listenTo(document.getElementById("boxCardRightBottom"), (element) => {
      this.cardHeight.rightBottomCard = element.offsetHeight;
      this.cardHeight.leftCard =
        this.cardHeight.rightTopCard + this.cardHeight.rightBottomCard + 5;
    });
  },
  computed: {},
  watch: {},

  methods: {
    getOrderDetail() {
      this.$post("pc_order/queryOrderDetail", {
        orderNo: this.orderNo,
      })
        .then((response) => {
          if (response.data.code === 0) {
            let data = response.data.data;
            this.tableData.orderPriceData = [data.orderPrice];
            this.tableData.orderBaseInfo = data.orderBaseInfo;
            this.orderId = this.tableData.orderBaseInfo.id;
            this.tableData.orderLeaveMessage = data.orderLeaveMessage;
            this.tableData.orderEvaluateDetailVo = data.orderEvaluateDetailVo;

            if (this.tableData.orderPriceData.length > 0) {
              this.refurndForm.orderMoney = this.tableData.orderPriceData[0].orderMoney;
              this.refurndForm.realReceiptMoney = this.tableData.orderPriceData[0].realReceiptMoney;
            }
            setTimeout(() => {
              this.queryOrderHandlerInfo();
              this.queryOrderJudge();
            }, 500);
          } else {
            this.$message.warning(response.data.msg);
          }
        })
        .catch((error) => {
          this.$message.error(error.message);
        });
    },
    saveMessage() {
      this.$post("pc_order/addOrderLeaveMessage", {
        orderNo: this.orderNo,
        newLeaveMessage: this.newLeaveMessage,
      })
        .then((response) => {
          if (response.data.code === 0) {
            this.newLeaveMessage = "";
            this.tableData.orderLeaveMessage = response.data.data;
          } else {
            this.$message.warning(response.data.msg);
          }
        })
        .catch((error) => {
          this.$message.error(error.message);
        });
    },
    canncelOrder() {
      this.canncelVisibile = true;
    },
    saveCanncel() {
      let remark = this.remark;
      if (remark == null || remark === "") {
        this.$message.warning("请输入取消原因");
        return false;
      }
      this.$post("pc_order/operationOrder", {
        orderNo: this.orderNo,
        orderStatus: 9,
        remark: remark,
      })
        .then((response) => {
          if (response.data.code === 0) {
            this.canncelVisibile = false;
            this.$message.success("取消成功");
            this.getOrderDetail();
          } else {
            this.$message.warning(response.data.msg);
          }
        })
        .catch((error) => {
          this.$message.error(error.message);
        });
    },
    /**
     * 查询华为隐私号录音
     */
    queryRecording() {
      this.$post("huaweiNumberRecord/queryOrderRecording", {
        orderNo: this.orderNo,
      })
        .then((success) => {
          if (success.data.code === 0) {
            this.recordingList = success.data.data;
            // if (this.recordingList.length === 0) {
            //   this.$message.warning("当前订单暂未查询到通话记录");
            // }
          } else {
            this.$message.warning(success.data.msg);
          }
        })
        .catch((error) => {
          this.$message.error(error.message);
        });
    },

    playRecording(index, row) {
      let audio = new Audio();
      audio.src = row.ossUrl;
      audio.play();
    },
    playOrderRadio(index, row) {
      let audio = new Audio();
      audio.src = row.contentRadioUrl;
      audio.play();
    },
    playOrderRecording(index, row) {
      let audio = new Audio();
      audio.src = row.recordingUrl;
      audio.play();
    },
    applyInvoice() {
      this.openInvoiceVisibile = true;
    },
    invoiceCommit() {
      this.openInvoiceForm.orderNo = this.orderNo;
      this.$post("invoice/fastOrderInvoice", this.openInvoiceForm)
        .then((response) => {
          if (response.data.code === 0) {
            this.$message.success("申请成功");
            this.getOrderDetail();
            this.openInvoiceVisibile = false;
          } else {
            this.$message.warning(response.data.msg);
          }
        })
        .catch((error) => {
          console.log(error.message);
        });
    },

    /**
     * 查询司机报备信息
     */
    queryOrderReport() {
      this.$post("orderReport/queryOrderReportByOrderNo", {
        orderNo: this.orderNo,
      })
        .then((success) => {
          if (success.data.code === 0) {
            this.orderReportList = success.data.data;
          } else {
            this.$message.warning(success.data.msg);
          }
        })
        .catch((error) => {
          this.$message.error(error.message);
        });
    },

    /**
     * 查询订单录音信息
     */
    queryOrderRecording() {
      this.orderRecordingMusic = [];
      this.$post("orderReport/queryOrderRecording", {
        orderNo: this.orderNo,
      })
        .then((success) => {
          if (success.data.code === 0) {
            let data = success.data.data;
            if ((data != null) & (data.length > 0)) {
              for (let index = 0; index < data.length; index++) {
                const element = data[index];
                let title = null;
                if (index < 9) {
                  title = "录音0" + (index + 1);
                } else {
                  title = "录音" + (index + 1);
                }
                this.orderRecordingMusic.push({
                  title: title,
                  src: element.recordingUrl,
                  artist: element.uploadTime,
                  pic: "../../../static/img/music.jpg",
                });
              }
            }
          } else {
            this.$message.warning(success.data.msg);
          }
        })
        .catch((error) => {
          this.$message.error(error.message);
        });
    },
    showTripartiteNo() {
      this.tripartiteNo = this.tableData.orderBaseInfo.partnerOrderId;
      this.tableData.orderBaseInfo.partnerOrderId = null;
    },
    openOrderStatusLog() {
      this.openOrderStatusVisibile = true;
      this.$post("pc_order/queryOrderStatusList", {
        orderId: this.orderId,
      })
        .then((success) => {
          if (success.data.code === 0) {
            this.orderStatusList = success.data.data;
          } else {
            this.$message.warning(success.data.msg);
          }
        })
        .catch((error) => {
          this.$message.error(error.message);
        });
    },

    /**查询订单处理信息 */
    queryOrderHandlerInfo() {
      this.$post("pc_order/queryOrderMarkByOrderId", {
        orderId: this.orderId,
      })
        .then((success) => {
          if (success.data.code === 0) {
            this.orderMarkList = success.data.data;
            if (this.orderMarkList.length > 0) {
              let refeudFlag = this.orderMarkList.filter(
                (item) => item.specialOperation === 4
              );
              if (refeudFlag.length > 0) {
                this.alreadyRefund = true;
                this.refuldResult = refeudFlag[0].remark;
              }
            }
          } else {
            this.$message.warning(success.data.msg);
          }
        })
        .catch((error) => {
          this.$message.error(error.message);
        });
    },
    refundClick() {
      this.openRefundVisible = true;
      this.refurndForm.orderId = this.orderId;
    },
    changeMoneyClick() {
      this.openChangeMoneyVisible = true;
      this.changeMoney.orderId = this.orderId;
      this.changeMoney.orderNo = this.orderNo;
      if (this.tableData.orderPriceData.length > 0) {
        this.changeMoney.originOrderMoney = this.tableData.orderPriceData[0].orderMoney;
        this.changeMoney.originMilesPrice = this.tableData.orderPriceData[0].milesPrice;
        this.changeMoney.originDurationPrice = this.tableData.orderPriceData[0].durationPrice;
        this.changeMoney.originadditionFee = this.tableData.orderPriceData[0].additionFee;
      }
       this.changeMoney.distancePrice = this.changeMoney.originMilesPrice 
       this.changeMoney.durationPrice =  this.changeMoney.originDurationPrice
       this.changeMoney.additionPrice = this.changeMoney.originadditionFee
    },
    setRefundMoney() {
      this.refurndForm.refundMoney = this.refurndForm.realReceiptMoney;
    },
    /**提交退款 */
    saveRefund() {
      this.$post("pc_order/orderRefund", this.refurndForm)
        .then((success) => {
          if (success.data.code === 0) {
            this.queryOrderHandlerInfo();
            this.$message.success("退款申请提交成功");
            this.openRefundVisible = false;
          } else {
            this.$message.warning(success.data.msg);
          }
        })
        .catch((error) => {
          this.$message.error(error.message);
        });
    },

    /**提交订单改价 */
    saveChangePrice() {
      this.$post("pc_order/changeOrderPrice", this.changeMoney)
        .then((success) => {
          if (success.data.code === 0) {
            this.queryOrderHandlerInfo();
            this.$message.success("订单价格已修改");
            this.openChangeMoneyVisible = false;
            this.queryPrice();
          } else {
            this.$message.warning(success.data.msg);
          }
        })
        .catch((error) => {
          this.$message.error(error.message);
        });
    },
    //提交订单判责
    commitJudge() {
      this.judgeForm.orderId = this.orderId;
      this.$post("orderJudge/saveOrderJudge", this.judgeForm)
        .then((success) => {
          if (success.data.code === 0) {
            this.$message.success("订单判责信息提交成功");
            this.orderJudgeList = success.data.data;
            if (this.orderJudgeList.length > 0) {
              let judgeClose = this.orderJudgeList.filter(
                (item) => item.ticketStatus === 2
              );
              if (judgeClose.length > 0) {
                this.orderTicketClose = true;
              }
            }
          } else {
            this.$message.warning(success.data.msg);
          }
        })
        .catch((error) => {
          this.$message.error(error.message);
        });
    },
    /**查询订单判责日志 */
    queryOrderJudge() {
      this.$post("orderJudge/queryOrderJudgeByOrderId", {
        orderId: this.orderId,
      })
        .then((success) => {
          if (success.data.code === 0) {
            this.orderJudgeList = success.data.data;
            if (this.orderJudgeList.length > 0) {
              let judgeClose = this.orderJudgeList.filter(
                (item) => item.ticketStatus === 2
              );
              if (judgeClose.length > 0) {
                this.orderTicketClose = true;
              }
            }
          } else {
            this.$message.warning(success.data.msg);
          }
        })
        .catch((error) => {
          this.$message.error(error.message);
        });
    },
    queryPrice() {
      this.$post("pc_order/getPriceByOrderId", {
        orderId: this.orderId,
      })
        .then((result) => {
          if (result.data.code === 0) {
            this.tableData.orderPriceData = [result.data.data];
          } else {
            this.$message.warning(result.data.msg);
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
  },
  filters: {
    operationFilter(value) {
      let result;
      switch (value) {
        case 1:
          result = "修改状态";
          break;
        case 2:
          result = "订单改派";
          break;
        case 3:
          result = "订单调帐";
          break;
        case 4:
          result = "订单退款";
          break;
        default:
          break;
      }
      return result;
    },
    //判决工单类型 1.成交率 2.行程服务 3.费用申诉
    ticketTypeFilter(value) {
      let result;
      switch (value) {
        case 1:
          result = "成交率";
          break;
        case 2:
          result = "行程服务";
          break;
        case 3:
          result = "费用申诉";
          break;
        default:
          break;
      }
      return result;
    },
    //责任主体 1.乘客主责 2.司机主责 3.双方无责
    dutySubjectFilter(value) {
      let result;
      switch (value) {
        case 1:
          result = "乘客主责";
          break;
        case 2:
          result = "司机主责";
          break;
        case 3:
          result = "双方无责";
          break;
        default:
          break;
      }
      return result;
    },
    //判责工单状态 1开启 2关闭
    ticketStatusFilter(value) {
      let result;
      switch (value) {
        case 1:
          result = "开启";
          break;
        case 2:
          result = "关闭";
          break;
        default:
          break;
      }
      return result;
    },
  },
};
</script>
<style  scoped>
.container {
  padding: 0 19px;
}
.table_header {
  font-size: 13px;
  font-weight: 800;
}

.baseInfo,
.baseInfo tr,
.baseInfo tr td {
  border: 1px solid #000000;
  margin: 0;
  padding: 8px;
  /* 合并边框 */
  border-collapse: collapse;
}

.baseInfo tr td:nth-child(odd) {
  word-break: break-word;
  background-color: #f8f8f9;
  color: #515a6e;
  height: 40px;
  font-size: 13px;
  font-weight: 800;
  padding: 0 12px;
  text-align: center;
}
.baseInfo tr td:nth-child(even) {
  width: 270px;
  font-size: 12px;
}
.baseInfo tr td:nth-child(2) {
  width: 300px;
}
.baseInfo tr td:nth-child(4) {
  width: 144px;
}
.baseInfo tr td:nth-child(6) {
  width: 350px;
}
.baseInfo tr td:nth-child(8) {
  width: 150px;
}
.baseInfo tr td:nth-child(10) {
  width: 285px;
}
#leaveDiv {
  height: auto;
  width: 91%;
  overflow: scroll;
  /* border:1px solid gray(200,200,200,0.5); */
  /* border: 1px solid rgba(200, 200, 200, 0.5); */
  font-size: 13px;
  /* border-bottom: 1px solid rgba(200, 200, 200, 0.5); */
  margin-bottom: -22px;
}

ul {
  padding-left: 10px;
}
ul li {
  list-style-type: none;
}

#recordingAplayre {
  position: absolute;
  right: 23%;
  top: 52%;
  width: 500px;
}
.tabImg {
  width: 50px;
  height: 50px;
  margin: 5px;
}
.tabImgPopup {
  width: 100%;
}

.clearfix:before,
.clearfix:after {
  display: table;
  content: "";
}
.clearfix:after {
  clear: both;
}
  .big_div {
  position: relative;
}
.box-card_left {
  width: 25%;
  position: absolute;
  overflow: scroll;
}
.box-card_right_top {
  width: 60%;
  margin-left: 26%;
  overflow: scroll;
}
.box-card_right_bottom {
  width: 60%;
  margin: 5px 0 0 26%;
  overflow: scroll;
}
.box-card_evaluate {
  width: 25%;
}
.orderHandlerLog {
  margin: 12px 0;
}
.judgeDutyLong {
  margin: 12px 0;
}
.refundP {
  margin-left: 2%;
}
</style>



// WEBPACK FOOTER //
// src/views/order/orderDetail.vue